var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.00195C23.55 8.00195 22.74 9.44195 23.07 10.512L19.52 14.072C19.22 13.982 18.78 13.982 18.48 14.072L15.93 11.522C16.27 10.452 15.46 9.00195 14 9.00195C12.55 9.00195 11.73 10.442 12.07 11.522L7.51 16.072C6.44 15.742 5 16.552 5 18.002C5 19.102 5.9 20.002 7 20.002C8.45 20.002 9.26 18.562 8.93 17.492L13.48 12.932C13.78 13.022 14.22 13.022 14.52 12.932L17.07 15.482C16.73 16.552 17.54 18.002 19 18.002C20.45 18.002 21.27 16.562 20.93 15.482L24.49 11.932C25.56 12.262 27 11.452 27 10.002C27 8.90195 26.1 8.00195 25 8.00195Z",
    fill: "#005CBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.00195L19.94 6.93195L22 6.00195L19.94 5.07195L19 3.00195L18.08 5.07195L16 6.00195L18.08 6.93195L19 9.00195Z",
    fill: "#005CBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.002L8 9.00195L10 8.50195L8 8.00195L7.5 6.00195L7 8.00195L5 8.50195L7 9.00195L7.5 11.002Z",
    fill: "#005CBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/Trend.d779e0c31027adca70e38a0056ca569e.svg";
export { ForwardRef as ReactComponent };